import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlaneDeparture, faPlane, faGears, faEnvelope, faSignOutAlt, faBell, faClock, faChartLine } from '@fortawesome/free-solid-svg-icons';

const iconMap = {
  'fas fa-plane-departure': faPlaneDeparture,
  'icon-flight': faPlane,
  'fas fa-gears': faGears,
  'icon-settings': faGears,
  'fas fa-bell': faBell,
  'fas fa-clock': faClock,
  'icon-messages': faEnvelope,
  'icon-logout': faSignOutAlt,
  'fas fa-chart-line': faChartLine,
};

const iconStyles = {
  'fas fa-plane-departure': { color: '#e8e814', fontSize: '14px' },
  'icon-flight': { color: '#2a2af0', fontSize: '14px' },
  'fas fa-gears': { color: '#f70505', fontSize: '14px' },
  'fas fa-bell': { marginRight: '10px', color: '#0a0a0a', fontSize: '14px' },
  'icon-logout': { color: '#24b324', fontSize: '14px' },
  'fas fa-chart-line': { color: '#10b981', fontSize: '14px' },
  'fas fa-clock': { color: '#f59e0b', fontSize: '14px' },
  'icon-logout': { color: '#24b324', fontSize: '14px' }
};

const Sidebar = ({ menuItems, activeItem, onMenuItemClick, isOpen, onClose }) => {
  const handleClick = (itemId) => {
    if (onMenuItemClick) {
      onMenuItemClick(itemId);
    } else {
      // onMenuItemClick is not defined
    }
    // Close sidebar on mobile after clicking
    if (onClose && window.innerWidth < 768) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <div className={`w-[200px] h-screen fixed left-0 top-[60px] overflow-y-auto z-50 bg-jet-gray-100 font-['Bahnschrift_Light','Segoe_UI',Tahoma,Geneva,Verdana,sans-serif] transition-transform duration-300 ease-in-out ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } md:translate-x-0`}>
        <div className="p-0">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`flex items-center py-3 px-4 cursor-pointer transition-colors duration-200 relative border-l-[3px] border-transparent font-semibold hover:bg-white ${
              activeItem === item.id ? 'bg-white' : ''
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleClick(item.id);
            }}
          >
            <span className="w-5 h-5 mr-3 flex items-center justify-center text-base">
              {iconMap[item.icon] ? (
                <FontAwesomeIcon 
                  icon={iconMap[item.icon]} 
                  style={iconStyles[item.icon] || {}}
                />
              ) : (
                <span className={item.icon}></span>
              )}
            </span>
            <span className="flex-1 text-[13px] text-jet-gray-800 font-semibold ml-2.5">{item.label}</span>
            {item.badge !== undefined && item.badge > 0 && (
              <span className="bg-jet-red-600 text-white rounded-full w-[18px] h-[18px] flex items-center justify-center text-[10px] font-semibold ml-auto">
                {item.badge}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default Sidebar;
